import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { useStateValue } from '../context/StateProvider';
import { doc, deleteDoc } from 'firebase/firestore';
import { firestore } from '../firebase.config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrash, FaBars } from 'react-icons/fa';
import moment from 'moment';

const ViewItemsContainer = () => {
  const [{ Products = [] }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items to show per page
  
  
  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };
  // State for filters
  const [filters, setFilters] = useState({
    jobTitle: '',
    company: '',
    location: '',
    postedDate: '',
  });


  const handleDelete = async (productId) => {
    if (window.confirm('Are you sure you want to delete this job?')) {
      try {
        const productDocRef = doc(firestore, 'Products', productId);
        await deleteDoc(productDocRef);
        const updatedProducts = Products.filter((product) => product.id !== productId);
        dispatch({
          type: 'SET_PRODUCTS',
          Products: updatedProducts,
        });
        toast.success('Job successfully deleted!');
        window.location.reload();
      } catch (error) {
        console.error('Error deleting job: ', error);
        toast.error('Error deleting job. Please try again.');
      }
    }
  };

  const handleUpdate = (productId) => {
    navigate(`/edit-product/${productId}`);
  };

  // Handle filter input change
  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const filteredProducts = Array.isArray(Products)
  ? Products.filter((product) => {
        const jobTitleMatch = filters.jobTitle
            ? product.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
            : true;
        const companyMatch = filters.company
            ? product.companyName.toLowerCase().includes(filters.company.toLowerCase())
            : true;
        const locationMatch = filters.location
            ? product.location.toLowerCase().includes(filters.location.toLowerCase())
            : true;

        // Corrected postedDate filtering
        const postedDateMatch = filters.postedDate
            ? new Date(product.postedDate).toISOString().split('T')[0] === filters.postedDate
            : true;

        return jobTitleMatch && companyMatch && locationMatch && postedDateMatch;
    })
  : []; // Return an empty array if Products is not an array
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
 // Function to format date
 const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
};

  return (
    <div className="lg:flex">
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />


          <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
        <h1 className="lg:text-2xl text-lg font-semibold mb-6 p-2">Job List</h1>

        {/* Filter Section */}
        <div className="mb-4 lg:flex lg:flex-row flex-col p-2">
          <input
            type="text"
            name="jobTitle"
            placeholder="Filter by Job Title"
            value={filters.jobTitle}
            onChange={handleFilterChange}
            className="p-2 border rounded mr-2 lg:mb-0 mb-2 lg:text-[15px] text-[13px]"
          />
          <input
            type="text"
            name="company"
            placeholder="Filter by Company"
            value={filters.company}
            onChange={handleFilterChange}
            className="p-2 border rounded mr-2 lg:mb-0 mb-2 lg:text-[15px] text-[13px]"
          />
          <input
            type="text"
            name="location"
            placeholder="Filter by Location"
            value={filters.location}
            onChange={handleFilterChange}
            className="p-2 border rounded mr-2 lg:mb-0 mb-2 lg:text-[15px] text-[13px]"
          />
          <input
            type="date"
            name="postedDate"
            placeholder="Filter by Posted Date"
            value={filters.postedDate}
            onChange={handleFilterChange}
            className="p-2 border rounded lg:text-[15px] text-[13px]"
          />
        </div>

        <div className="overflow-x-auto p-2">
          <table className="min-w-full bg-white border border-gray-300 rounded-md shadow-sm text-sm">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-300">
                <th className="py-2 px-4 text-left">ID</th>
                <th className="py-2 px-4 text-left">Job Title</th>
                <th className="py-2 px-4 text-left">Company</th>
                <th className="py-2 px-4 text-left">Location</th>
                <th className="py-2 px-4 text-left">Salary</th>
                <th className="py-2 px-4 text-left">Experience Required</th>
                <th className="py-2 px-4 text-left">Posted Date</th>
                <th className="py-2 px-4 text-left">Application Deadline</th>
                <th className="py-2 px-4 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.length > 0 ? (
                currentProducts.map((product) => (
                  <tr key={product.id} className="border-b border-gray-300 hover:bg-gray-50">
                    <td className="py-2 px-4">{product.id}</td>
                    <td className="py-2 px-4">{product.jobTitle}</td>
                    <td className="py-2 px-4">{product.companyName}</td>
                    <td className="py-2 px-4">{product.location}</td>
                    <td className="py-2 px-4">₹{product.salary}</td>
                    <td className="py-2 px-4">{product.experienceRequired}</td>
                    <td className="py-2 px-4">{formatDate(product.postedDate)}</td>
                    <td className="py-2 px-4">{formatDate(product.applicationDeadline)}</td>
                    <td className="py-2 px-4 flex space-x-2">
                      <button
                        className="text-blue-500 hover:text-blue-700 transition-colors duration-200"
                        onClick={() => handleUpdate(product.id)}
                        title="Edit Job"
                      >
                        <FaEdit size={13} />
                      </button>
                      <button
                        className="text-red-500 hover:text-red-700 transition-colors duration-200"
                        onClick={() => handleDelete(product.id)}
                        title="Delete Job"
                      >
                        <FaTrash size={13} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    No Jobs found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination controls */}
        <div className="lg:flex lg:flex-row flex-col justify-center items-center mt-4 space-x-2 p-2">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`px-4 py-2 border rounded-lg transition duration-200 ${
              currentPage === 1
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed' // Disabled style
                : 'bg-blue-500 text-white hover:bg-blue-600 cursor-pointer' // Active style
            }`}
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded-lg transition duration-200 ${
                currentPage === index + 1
                  ? 'bg-blue-500 text-white' // Active page button style
                  : 'bg-white text-blue-500 hover:bg-blue-100' // Non-active button style
              }`}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 border rounded-lg transition duration-200 ${
              currentPage === totalPages
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed' // Disabled style
                : 'bg-blue-500 text-white hover:bg-blue-600 cursor-pointer' // Active style
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewItemsContainer;
